export default __webpack_public_path__ + "static/media/detail_big_4_3.fae1e6c4.png";